import type { EventsDigestedLineChartDisplayInterval } from '../events-digested-line-chart/events-digested-line-chart';
import { DISPLAY_INTERVALS } from '../events-digested-line-chart/events-digested-line-chart';

export function getEventsIntervalLabel(interval: EventsDigestedLineChartDisplayInterval) {
  return interval === DISPLAY_INTERVALS.daily ? 'Daily' : 'Monthly';
}
